import React from "react";
import PricingCard from "../common/PricingCard";
import { makeStyles, Container, Grid } from "@material-ui/core";
import NtkParagraph from "../common/NtkParagraph";
import NtkHeader from "../common/NtkHeader";
const useStyles = makeStyles((theme) => ({
  root: {
    margin: "3.812rem auto 6.06rem auto",
  },
  priceText: {
    textAlign: "center",
    marginTop: "1rem",
  },
  cardList: {
    justifyContent: "center",
    marginTop: "5.625rem",
    [theme.breakpoints.only("xs")]: {
      marginTop: "2.625rem",
    },
  },
}));

const data = [
  ["$ 15 / per session", "$ 70 / per bundle"],
  [
    "One to one language sessions with a Conversation Partner.",
    "A bundle of five one to one language sessions with a Conversation",
  ],
];

const Pricing = () => {
  const classes = useStyles();

  return (
    <Container maxWidth="xl" className={classes.root}>
      <NtkHeader header=" Pricing" />

      <NtkParagraph
        paragraph="A portion of every session goes directly to support our Conversation
        Partners getting a living wage and regaining their dignity and
        livelihoods through language learning."
      />

      <Container>
        <Grid container spacing={3} className={classes.cardList}>
          {data.map((d, i) => (
            <Grid item md={6} sm={8} xs={12} key={d}>
              <PricingCard title={data[0][i]} text={data[1][i]} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Container>
  );
};

export default Pricing;
